import { TaskColumnOption } from "@common-models/task-column-option";
import { Button } from "@mui/material";
import { BiPencil } from "react-icons/bi";
import classes from "./picker-dialog.module.scss";
import ComplexityBadge from "./complexity-badge";

type Props = {
  options: TaskColumnOption[];
  handleValueSelected: (option: any) => void;
  onEdit: () => void;
  canEdit?: boolean;
  isComplexity?: boolean;
  editLabelsString?: string;
};

export default function MappedOptions({
  options,
  handleValueSelected,
  onEdit,
  canEdit,
  isComplexity,
  editLabelsString,
}: Props) {
  function changeToEditMode() {
    onEdit();
  }

  return (<>
    <div className={classes.label_container}>
      {/* Render custom labels */}
      {[...(options ?? [])]
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
        .map((option: TaskColumnOption) => (
          <div key={option._id}  >

            {!isComplexity &&
              <button
                onClick={() => handleValueSelected(option)}
                className={classes.pickerBtn}
                style={{
                  backgroundColor: option?.bgcolor,
                  color: "var(--task-option-text)",
                  textTransform: "capitalize",
                  marginTop: 5,
                  boxShadow: "none",
                  fontSize: 12,
                  borderRadius: 5,
                  fontWeight: "600",
                  fontFamily: "'Inter', 'Assistant', sans-serif",
                  height: 28,
                  // marginLeft: 25,
                  // marginRight: 25,
                  width: '100%',
                  maxWidth: '180px',
                }}
              >
                {option?.label}
              </button>
            }
            {isComplexity &&
              <button
                onClick={() => handleValueSelected(option)}
                className={classes.pickerBtn}
                style={{
                  backgroundColor: option?.bgcolor,
                  color: "var(--task-option-text)",
                  textTransform: "capitalize",
                  marginTop: 5,
                  boxShadow: "none",
                  fontSize: 12,
                  borderRadius: 5,
                  fontWeight: "600",
                  fontFamily: "'Inter', 'Assistant', sans-serif",
                  height: 28,
                  // marginLeft: 25,
                  // marginRight: 25,
                  width: '100%',
                  maxWidth: '180px',
                }}
              >
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 6,
                  paddingRight: '4px',
                  paddingLeft: '6px'
                }}>
                  <div>{option?.label ?? ''}</div>
                  <ComplexityBadge value={option?.complexity} />
                </div>
              </button>
            }
          </div>
        ))}
    </div>

    <div className={classes.edit_labels_button_wrap}>
      <Button
        onClick={changeToEditMode}
        disabled={!canEdit}
        className={classes.edit_labels_button}
        style={{
          textTransform: "capitalize",
          marginTop: 5,
          boxShadow: "none",
          fontSize: 12,
          borderRadius: 0,
          color: '#063448',
        }}
      >
        <BiPencil size={16} />
        <p style={{
          margin: '0px 5px',
          fontFamily: "'Inter', sans-serif",
          fontWeight: "600",
          fontSize: 14,
        }}>
          {editLabelsString}
        </p>
      </Button>
    </div>
  </>

  );
}









